import { c as _c } from "react/compiler-runtime";
import { DEFAULT_SIZE_UNIT, getSizeRangeFilterId, parseSizeRangeFilterId } from "@components/projects/projects-filters/projects-size-filter-utils";
import { SizeLimitField } from "@components/projects/projects-filters/size-filter/size-limit-field";
import { Button, ChevronLeftIcon, IconButton, Text } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { useState } from "react";
/** The fields to type the limits of a custom size range in, shown in the dropdown of the size chip */
export function SizeCustomRange(t0) {
  const $ = _c(43);
  const {
    activeRange,
    onBack,
    onCancel,
    onApply
  } = t0;
  let t1;
  if ($[0] !== activeRange?.min) {
    t1 = () => toLimitInput(activeRange?.min);
    $[0] = activeRange?.min;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [min, setMin] = useState(t1);
  let t2;
  if ($[2] !== activeRange?.max) {
    t2 = () => toLimitInput(activeRange?.max);
    $[2] = activeRange?.max;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const [max, setMax] = useState(t2);
  let range;
  let t3;
  if ($[4] !== max || $[5] !== min) {
    range = toSizeRange(min, max);
    t3 = range !== undefined && parseSizeRangeFilterId(getSizeRangeFilterId(range)) === undefined;
    $[4] = max;
    $[5] = min;
    $[6] = range;
    $[7] = t3;
  } else {
    range = $[6];
    t3 = $[7];
  }
  const isReversed = t3;
  const canApply = range ? !isReversed : activeRange !== undefined;
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      px: 2,
      py: 1,
      gap: 1.5
    };
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      alignItems: "center",
      gap: 0.5
    };
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ChevronLeftIcon />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== onBack) {
    t7 = <IconButton aria-label="Back to the sizes" size="s" onClick={onBack}>{t6}</IconButton>;
    $[11] = onBack;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Text variant="heading14">Custom range</Text>;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t7) {
    t9 = <Stack direction="row" sx={t5}>{t7}{t8}</Stack>;
    $[14] = t7;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== min) {
    t10 = <SizeLimitField label="Min" limit={min} onLimitChange={setMin} />;
    $[16] = min;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== max) {
    t11 = <SizeLimitField label="Max" limit={max} onLimitChange={setMax} />;
    $[18] = max;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const t12 = isReversed ? "error.main" : "text.secondary";
  let t13;
  if ($[20] !== t12) {
    t13 = {
      color: t12
    };
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  const t14 = isReversed ? "The minimum must not be larger than the maximum." : "Sizes include both limits. Leave a field empty for no limit.";
  let t15;
  if ($[22] !== t13 || $[23] !== t14) {
    t15 = <Text variant="bodyS" sx={t13}>{t14}</Text>;
    $[22] = t13;
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      justifyContent: "flex-end",
      gap: 1
    };
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== onCancel) {
    t17 = <Button variant="secondary" onClick={onCancel}>Cancel</Button>;
    $[26] = onCancel;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  const t18 = !canApply;
  let t19;
  if ($[28] !== onApply || $[29] !== range) {
    t19 = () => onApply(range);
    $[28] = onApply;
    $[29] = range;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== t18 || $[32] !== t19) {
    t20 = <Button variant="primary" disabled={t18} onClick={t19}>Apply</Button>;
    $[31] = t18;
    $[32] = t19;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== t17 || $[35] !== t20) {
    t21 = <Stack direction="row" sx={t16}>{t17}{t20}</Stack>;
    $[34] = t17;
    $[35] = t20;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== t10 || $[38] !== t11 || $[39] !== t15 || $[40] !== t21 || $[41] !== t9) {
    t22 = <Stack sx={t4} onKeyDown={_temp}>{t9}{t10}{t11}{t15}{t21}</Stack>;
    $[37] = t10;
    $[38] = t11;
    $[39] = t15;
    $[40] = t21;
    $[41] = t9;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  return t22;
}

/** Returns the limit as the field shows it, which is empty with the default unit for no limit */
function _temp(event) {
  return event.stopPropagation();
}
function toLimitInput(limit) {
  return limit ?? {
    value: null,
    unit: DEFAULT_SIZE_UNIT
  };
}

/** Returns the range of the typed limits, or undefined if both fields are empty */
function toSizeRange(min, max) {
  const range = {
    min: toSizeLimit(min),
    max: toSizeLimit(max)
  };
  return range.min || range.max ? range : undefined;
}

/** Returns the typed limit, or undefined if its field is empty */
function toSizeLimit({
  value,
  unit
}) {
  return value === null ? undefined : {
    value,
    unit
  };
}